import React, { type ComponentType } from "react";

import { useSession } from "./useSession";

import { type AppUserSession } from "@/schemas/auth/session";
import { type WithSessionHandlingProps } from "@/schemas/user/restriction";
import LandingScreen from "@/screens/LandingScreen";
import LoadingScreen from "@/screens/Loading/LoadingScreen";

export type SessionHandlerProps = {
  session: AppUserSession;
};

function withSessionHandling<P extends WithSessionHandlingProps>(
  WrappedComponent: ComponentType<P>,
): ComponentType<Omit<P, "session">> {
  return function SessionHandlingComponent(props: Omit<P, "session">) {
    const { session, isSessionLoading } = useSession();

    if (isSessionLoading) {
      return <LoadingScreen />;
    }

    if (!session) {
      return <LandingScreen />;
    }

    return <WrappedComponent {...(props as P)} session={session} />;
  };
}

export default withSessionHandling;
